import React from 'react';
import fill from 'fill-range';
import styles from './DesktopAdStructure.module.scss';
import {MDBCol, MDBRow} from 'mdbreact';
import {IProduct} from 'data/interfaces/products';
import AdControl from '../../../adControl/AdControl';
import AdPrices from '../../../adPrices/AdPrices';
import {Else, If, Then} from 'react-if';
import AdPurchase from '../../../adPurchase/AdPurchase';
import Section from './components/sections/components/section';
import Sections from './components/sections/Sections';
import GenericImageSquare from '../../../genericImageSquare';
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';
import TopTab from '../topTab';
import {eSavingsType} from '../../../adPurchase/components/adSavings';

export interface IDesktopAdStructureProps {
  product?: IProduct;
  displaySquare?: any;
  cardTitle?: any;
  specialDetails?: any;
  specialDetails2?: any;
  timeRemaining?: number;
  salePriceLabel?: any;
  originalPriceLabel?: any;
  originalPrice?: number;
  originalPriceClassName?: string;
  salePrice?: number;

  additionalRows?: any;

  hideControl?: boolean | any;
  hideStatus?: boolean;
  showPurchase?: boolean;
  statusToText?: (status: number) => string;
  status?: number;
  statusComponent?: any;

  view?: (id: number) => void;
  edit?: (id: number) => void;
  delete?: (id: number) => void;

  loading?: boolean;

  savingsType?: eSavingsType;
}

const DesktopAdStructure = (props: IDesktopAdStructureProps) => {
  return (
    <div className={styles.desktopAdStructure}>
      <TopTab {...props}/>
      {(props.loading && !props.displaySquare) ?
        <GenericImageSquare loading={true}/>
        : <props.displaySquare product={props.product}/>}
      <span className={styles.line}>
          <MDBRow style={{margin: 0}}>
                  <MDBCol sm="12">
                    <MDBRow style={{padding: 0, margin: 0, marginTop: 10}}>
                      <MDBCol style={{padding: 0}}>
                        <h6 className={styles.adCardTitle}>
                          {props.loading ? <SkeletonPlaceHolder
                            variant="text"
                            width={302}/> : props.cardTitle}
                        </h6>
                      </MDBCol>
                    </MDBRow>
                    <MDBRow style={{padding: 0, margin: 0}} className='detailLine'>
                       <Sections
                         sections={[
                           {
                             width: 200,
                             children: props.loading ? fill(0, 5).map(i => <SkeletonPlaceHolder
                               key={i}
                               variant="text"
                               width={150}
                               height={15}/>) : props.specialDetails
                           },
                           {
                             width: 150,
                             children: props.loading ? null : props.specialDetails2
                           },
                         ]}
                       />
                      <Section width={253}>
                        <AdPrices salePriceLabel={props.salePriceLabel}
                                  originalPriceLabel={props.originalPriceLabel}
                                  originalPrice={props.originalPrice}
                                  originalPriceClassName={props.originalPriceClassName}
                                  salePrice={props.salePrice || props.product.saleDetails.askingPrice}
                                  currency={props.product.saleDetails.currency}
                                  loading={props.loading}
                        />
                      </Section>
                      <If condition={props.hideControl === true}>
                        <Else>
                          {() => <Section>
                            <AdControl
                              hideControl={props.hideControl}
                              product={props.product}
                              edit={props.edit}
                              view={props.view}
                              delete={props.delete}
                              loading={props.loading}
                            />
                          </Section>}
                        </Else>
                      </If>
                      <If condition={!!props.showPurchase}>
                        <Then>
                          {() => <Section
                          >
                            <AdPurchase
                              product={props.product}
                              savingsType={props.savingsType}
                              loading={props.loading}
                            />
                          </Section>}
                        </Then>
                      </If>
                    </MDBRow>
                    {props.additionalRows}
                  </MDBCol>
                </MDBRow>
      </span>
    </div>
  );
}

DesktopAdStructure.defaultProps = {

  displaySquare: null,
  cardTitle: null,
  specialDetails: null,
  specialDetails2: null,
  timeRemaining: 0,
  originalPrice: 0,
  additionalRows: null,

  hideControl: false,
  hideStatus: false,

  view: () => {
  },
  edit: () => {
  },
  delete: () => {
  },
};
export default DesktopAdStructure;
